import { UAParser } from "ua-parser-js";
export class Device {
    static isTouchDevice() {
        return ("ontouchstart" in window &&
            window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Windows Phone)|(IEMobile)|(iemobile)|(Opera Mini)|(BlackBerry)/i) !== null);
    }
    static isMobile() {
        const ua = new UAParser();
        return ua.getDevice().type === "mobile";
    }
}
